import {useEffect} from "react";
import {useLocation} from "react-router-dom";
import {Stack, Box, useTheme} from "@mui/material";
import {CervinoHeaderText} from "../components/typography/CervinoHeaderText";
import {trackEvent} from "../utils/analytics";

export default function ErrorPage() {
    const theme = useTheme();
    const location = useLocation();

    useEffect(() => {
        trackEvent("page_not_found", {
            page_path: location.pathname + location.search,
        });
    }, [location.pathname, location.search]);

    return (
        <Stack spacing={2} alignItems="center" textAlign="center">
            <Box paddingY={{xs: 10, sm: 15}}>
                <CervinoHeaderText
                    color= {theme.palette.primary.main}
                    sx={{fontSize: { xs: "1.8rem", sm: "3rem", md: "4rem", lg: "5rem", xl: "6rem" }}}
                >
                    Sorry, page not found.
                </CervinoHeaderText>
            </Box>
        </Stack>
    );
}
